import { Link } from 'react-router-dom';
import { categoryGroups } from '@/mocks/categories';
import { getMoviesByType } from '@/lib/movieUtils';

export default function CategoryShortcuts() {
  return (
    <section className="max-w-[1280px] mx-auto px-4 md:px-8">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-5">
        {categoryGroups.map((group) => {
          const count = getMoviesByType(group.type).length;
          return (
            <Link
              key={group.type}
              to={`/category/${group.type}`}
              className="group flex items-center gap-3 md:gap-4 p-4 md:p-5 bg-background-50 border border-background-200 rounded-lg hover:border-primary-300 transition-colors"
            >
              <span className="w-12 h-12 md:w-14 md:h-14 shrink-0 rounded-lg bg-primary-50 text-primary-500 flex items-center justify-center group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                <i className={`${group.icon} text-2xl md:text-3xl`}></i>
              </span>
              <span className="min-w-0">
                <span className="block font-semibold text-foreground-950 whitespace-nowrap">{group.name}</span>
                <span className="block text-xs text-foreground-500 mt-0.5">{count} 部资源</span>
              </span>
            </Link>
          );
        })}
      </div>
    </section>
  );
}